module.exports = __webpack_public_path__ + "static/media/photo-camera.8b6ad68e.svg";